<template>
  <!--begin::Wrapper-->
  <div class="w-lg-600px bg-white rounded p-10 p-lg-15 mx-auto">
    <!--begin::Form-->
    <Form
      class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
      @submit="onSubmitForgotPassword"
      id="kt_login_password_reset_form"
      :validation-schema="forgotPassword"
    >
      <!--begin::Heading-->
      <div class="text-center mb-10">
        <!--begin::Title-->
        <h1 class="text-dark mb-3">{{$t("Mot de passe oublié ?")}}</h1>
        <!--end::Title-->

        <!--begin::Link-->
        <div class="text-gray-800 fw-bold fs-3">
          <br />
          {{$t("Veuillez nous contacter au")}} 01 60 92 41 00
          <br />
          {{$t("afin de procéder à la vérification de votre identité")}}
          <br />
          {{$t("et la réinitilisation de votre mot de passe.")}}
          <br />
        </div>
        <!--end::Link-->
      </div>

      <div class="fv-row mb-10">
        <div class="d-flex flex-wrap justify-content-center pb-lg-0">
          <router-link
            to="/sign-in"
            class="btn btn-lg btn-light-primary fw-bolder me-4"
            >{{$t("Retour à la page de connexion")}}</router-link
          >
        </div>
      </div>

      <!--begin::Heading-->
      <!--
      <div class="fv-row mb-10">
        <label class="form-label fw-bolder text-gray-900 fs-6">Email</label>
        <Field
          class="form-control form-control-solid"
          type="email"
          placeholder=""
          name="email"
          autocomplete="off"
        />
        <div class="fv-plugins-message-container">
          <div class="fv-help-block">
            <ErrorMessage name="email" />
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-center pb-lg-0">
        <router-link
          to="/sign-in"
          class="btn btn-lg btn-light-primary fw-bolder me-4"
          >Annuler</router-link
        >
        <button
          type="submit"
          ref="submitButton"
          id="kt_password_reset_submit"
          class="btn btn-lg btn-primary fw-bolder me-4"
        >
          <span class="indicator-label">
            Réinitialiser votre mot de passe
          </span>
          <span class="indicator-progress">
            Veuillez patientez...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </button>
      </div>
      -->
    </Form>
    <!--end::Form-->
  </div>
  <!--end::Wrapper-->
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Form } from "vee-validate";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import * as Yup from "yup";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  name: "password-reset",
  components: {
    Form,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const forgotPassword = Yup.object().shape({
      email: Yup.string()
        .email("Veuillez saisir un mail valide, svp")
        .required("Le mail est requis, svp.")
        .label("Email"),
    });

    //Form submit function
    const onSubmitForgotPassword = (values) => {
      // Activate loading indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.FORGOT_PASSWORD, values)
          .then(() => {
            Swal.fire({
              text: "All is cool! Now you submit this form",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              // Go to page after successfully login
              router.push({ name: "dashboard" });
            });
          })
          .catch(() => {
            // Alert then login failed
            Swal.fire({
              text: store.getters.getErrors[0],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        submitButton.value?.removeAttribute("data-kt-indicator");
      }, 2000);
    };

    return {
      onSubmitForgotPassword,
      forgotPassword,
      submitButton,
    };
  },
});
</script>
